<template>
	<slot v-bind="canUserJoinWorkspace" />
</template>

<script>
import {useCanUserJoinWorkspace} from 'shared/composables/useCanUserJoinWorkspace'

export default {
	name: 'CanUserJoinWorkspace',
	setup() {
		const canUserJoinWorkspace = useCanUserJoinWorkspace()
		return {
			canUserJoinWorkspace,
		}
	},
}
</script>
